import { ReactElement } from "react";

export const Done = (): ReactElement => {
  return (
    <div className={'rules rel'}>
      <div className={'pb_finished bubble bubble_purple bubble_bottom'}>
        <h1 className={'headline font_beige'}>Твой промокод скоро придёт тебе на почту! </h1>
        <p className={'font_white'}>
          Проверь свои сообщения.
        </p>
        <div className={'rules__gears'}/>
      </div>
      <div className={'auth__machine-wrap'}>
        <div className={'auth__machine'}></div>
      </div>
    </div>
  )
}